import React, { useState,useEffect } from 'react';
import {
    Button,Layout,
    Row,Col, Modal,
} from 'antd';
import IF from '@/components/IF';
import {
    PlusOutlined,
} from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import SoilTable from '@/components/SoilTable';

import { RootState } from '@/redux';
const { Content } = Layout;
import { GetAnalysesList } from '@/util/Request';
import TableHeaderCell from '@/page/Soil/soil-profile/Component/TableHeaderCell';
import AddModel from './Component/AddModel/AddModel';
import HeaderSearch from '@/components/HeaderSearch';
import './index.less';
import DetailModel from './Component/DetailModel/DetailModel';
import moment from 'moment';
import SoilAnalysisImage from '@/resource/icon-png/soil-analysis-header-pic.png';
import { ExclamationMarkSvgComponent, SoilCloseIcon } from '@/resource/IconComponentSets';
import { getSoilAnalysisList } from '@/redux/reducer/referenceData';
const SoilAnalyses = () => {
    const {deleteFiled} = useSelector((state: RootState) =>state.commonData);
    const [pageIndex,setpageIndex] = useState<number>(1);
    const dispatch = useDispatch();
    const {userInfo} = useSelector((state: RootState) =>
        state.soilUser);
    const {soilAnalysisList} = useSelector((state: RootState) =>
        state.referencePageData);
    const [visible, setVisible] = useState(false);
    const [editParam,setEditParam] = useState({});
    const [editItem,setEditItem] = useState({} as any);
    const [seaParam,setSeahParam] = useState<string>('');
    const [desc,setDesc] = useState('DESC');
    const [soilAnalysisNoticeShow, setSoilAnalysisNoticeShow] = useState(false);
    const [lock, setLock] = useState(false);
    const [data,setData] = useState([] as any);
    const [orgiginData, setOrgiginData] = useState([] as any);
    const [firstIn, setFirstIn] = useState(true);
    const [currentStatus, setCurrentStatus] = useState<string>('All');

    useEffect(() => {
        if (!firstIn) {
            GetAnalyses(seaParam, pageIndex, currentStatus);
        }
    }, [deleteFiled]);

    const GetAnalyses = async (param=seaParam,page=pageIndex, localCurrentStatus?: string)=>{
        try {
            if(lock) {
                return;
            }
            setLock(true);
            setSeahParam(param);
            const res = await GetAnalysesList(param,'sampleDate',desc,page,localCurrentStatus);
            dispatch(getSoilAnalysisList({soilAnalysisList: res}));
            setOrgiginData(res);
            setLock(false);
            if (firstIn) {
                setFirstIn(false);
            }
            setIsFetching(false);
        } catch(err) {
            setIsFetching(false);
            setLock(false);
            if (firstIn) {
                setFirstIn(false);
            }
        }
    };
    const [visible2, setVisible2] = useState(false);
    const lookItem = async (item)=>{
        console.log(item);
        console.log(userInfo);
        setEditItem(item);
        dispatch({
            type: 'common/closeDownFile'
        });
        setVisible2(true);
    };
    useEffect(() => {
        GetAnalyses('');
    }, [desc]);

    // handle fieldType filter
    const handleFilterTargetType = (targetStatus: string) => {
        setCurrentStatus(targetStatus);
        // if (targetStatus === 'All') {
        //     return dispatch(getSoilAnalysisList({soilAnalysisList: [...orgiginData]}));
        // }
        // const targetArr = orgiginData.filter((item) => {
        //     return item.status === targetStatus;
        // });
        // dispatch(getSoilAnalysisList({soilAnalysisList: targetArr}));
        setpageIndex(1);
        GetAnalyses('', 1, targetStatus);
    };

    // useEffect(() => {
    //     const statusSet = new Set<string>();
    //     statusSet.add('all');
    //     if (orgiginData.length > 0) {
    //         orgiginData.forEach(ele => {
    //             statusSet.add(ele.status);
    //         });
    //     }
    //     setFilterDatSource(statusSet);
    // }, [orgiginData]);

    const columns = [
        {
            title: 'Upload ID',
            dataIndex: 'sampleCode',
            render: (text, record, index) => <a onClick={e=> {
                lookItem(record);
            }}>{record.sampleCode}</a>
        },
        {
            title: 'Layer',
            dataIndex: 'layer'
        },
        {
            title: 'Profile Name',
            dataIndex: 'profileName',
        },
        {
            title: <TableHeaderCell
                title="Status"
                type='filter'
                filterIconSide='right'
                filterSourceArray={['All', 'Draft', 'Obsolete', 'Published']}
                filterCallBack={(item) => handleFilterTargetType(item)}
            />,
            dataIndex: 'status',
        },
        {
            // title: 'Date',
            title: () =><TableHeaderCell
                title='Date'
                type='sort'
                sortCallBack={(sortAscending) => {
                    console.log(sortAscending);
                    if(sortAscending){
                        setDesc('ASC');
                    }else{
                        setDesc('DESC');
                    }
                }}
            />,
            dataIndex: 'sampleDate',
            // sorter: {
            //     compare: (a, b) => a.age < b.age ? -1 : 1,
            //     multiple: 5,
            // },
            render: (text, record) => <span onClick={e=> {
                lookItem(record);
            }}>{moment(text).format('YYYY-MM-DD')}</span>
        },
    ];
    const visibleCallback = (param)=>{
        console.log(param);
        setEditParam(null);
        setVisible(param);
        // setTimeout(e=>{
        //     setVisible(param);
        // });
    };
    const editCallback = (param)=>{
        setEditParam(param);
        setVisible(true);
    };


    const [isFetching, setIsFetching] = useState(false);
    useEffect(() => {
        window.addEventListener('scroll', () => handleScroll());
        return () => window.removeEventListener('scroll', () => handleScroll());
    }, []);
    const handleScroll = () => {
        if (window.innerHeight + document.documentElement.scrollTop > document.body.scrollHeight - 50 ) {
            setIsFetching(true);
        } else {
            // console.log('unreach');
        }
    };
    // SECTION: test
    useEffect(() => {
        if (!isFetching) return;
        setpageIndex(pageIndex+1);
        GetAnalyses(seaParam,pageIndex+1, currentStatus);
    }, [isFetching]);

    return (
        <div className="test">
            <Modal
                open={soilAnalysisNoticeShow}
                title='Soil Analysis'
                style={{
                    position: 'absolute',
                    top: '100px',
                    left: '100px',
                    borderRadius: '4px !important',
                    height: '200px',
                }}
                width='340px'
                footer={null}
                closeIcon={<SoilCloseIcon />}
                onCancel={() => {
                    setSoilAnalysisNoticeShow(false);
                }}
                onOk={() => setSoilAnalysisNoticeShow(false)}
            >
                <div className='profile-count-container'>
                    <div className='profile-count-image'>
                        <img src={SoilAnalysisImage} className='profile-count-image-style' />
                    </div>
                    <div>
                        Soil analysis provides fundamental knowledge on the chemical, physical and biological status of a soil.
                    </div>
                </div>
            </Modal>
            <DetailModel visible={visible2} editItem={editItem} edit={editCallback}
                childChangeIsShowPreviewModal={()=>{setVisible2(false);}}
            />
            <AddModel visible={visible} visibleCallback={visibleCallback} editParam={editParam} defaultProfileid={null}/>
            <h3 className="soliHeader">Soil Analysis
                {/* <InfoCircleOutlined style={{margin:'5px 0 0 10px'}} /> */}
                <button className="exclamation-button" onClick={() => setSoilAnalysisNoticeShow(true)}>
                    <ExclamationMarkSvgComponent />
                </button>
            </h3>
            <Row>
                <Col span={12}>
                    <HeaderSearch GetAnalyses={(searchParam: string) => {
                        setpageIndex(1);
                        GetAnalyses(searchParam, 1);
                    }} placeholder='Search'/>
                </Col>
                <Col span={12}>
                    <h3 className="tableBox" style={{justifyContent:'flex-end'}}>
                        <IF show={userInfo?.roleName!='Reader'}>
                            <Button
                                shape="round"
                                size='large'
                                className='soil-button'
                                style={{background:'#59B948',color:'#fff'}}
                                icon={ <PlusOutlined /> } onClick={e=>{
                                    // c.propertyValues
                                    const param = {
                                        sampleStatusID:1,
                                        sampleid:'',
                                        samples:{
                                            propertyValues:[
                                                {
                                                    key: '0',
                                                    unitCode:'',
                                                    propertyName: 'Select Soil Properties',
                                                    propertyValue: ' ',
                                                    methodName: 'Select Estimation Method',
                                                    hasTag:false,
                                                    propMeasurementID:'',
                                                    propertyClass:'TYPE'
                                                }
                                            ]
                                        }
                                    };
                                    setEditParam(param);
                                    setVisible(true);
                                    dispatch({
                                        type: 'common/closeDownFile'
                                    });
                                }}>
                            Add Soil Analysis
                            </Button>
                        </IF>
                    </h3>
                </Col>
            </Row>

            <div className="tableBox">
                <Content style={{ backgroundColor: '#fff' }}>
                    <SoilTable
                        rowKey={record => record.id}
                        columns={columns}
                        dataSource={soilAnalysisList}
                        pagination={false}
                    />
                </Content>
            </div>
        </div>
    );
};
export default SoilAnalyses;
